import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error('Please fill in all fields');
    setLoading(true);
    try {
      const data = await login(email.trim(), password);
      navigate(data.redirectTo, { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@700&family=Exo+2:wght@400;600;700;900&display=swap');
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
        @keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
        .lcard{animation:fadeUp .5s ease both}
        .linput:focus{border-color:rgba(0,200,255,.5)!important;outline:none}
        .lbtn:hover{background:#00C8FF!important;transform:translateY(-1px)}
      `}</style>
      <div style={s.bgGrid} />
      <div style={s.bgGlow} />

      <div className="lcard" style={s.card}>
        <div style={s.logo}>
          {/* <img src="/logo.jpg" alt="AIA74" style={{ height: '80px', width: 'auto', objectFit: 'contain', marginBottom: '8px' }} /> */}
          <span style={s.logoSub}>SIGN IN TO YOUR ACCOUNT</span>
        </div>

        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.field}>
            <label style={s.label}>EMAIL</label>
            <input className="linput" style={s.input} type="email" placeholder="your@email.com"
              value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" autoFocus />
          </div>
          <div style={s.field}>
            <label style={s.label}>PASSWORD</label>
            <input className="linput" style={s.input} type="password" placeholder="Your password"
              value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" />
          </div>
          <button className="lbtn" style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
            {loading ? 'Signing in...' : 'SIGN IN →'}
          </button>
        </form>

        <p style={s.switchText}>
          New player? <Link to="/register" style={s.switchLink}>Create Account</Link>
        </p>
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: '#080c14', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontFamily: "'Exo 2',sans-serif", position: 'relative', overflow: 'hidden' },
  bgGrid: { position: 'fixed', inset: 0, backgroundImage: 'linear-gradient(rgba(0,200,255,.03) 1px,transparent 1px),linear-gradient(90deg,rgba(0,200,255,.03) 1px,transparent 1px)', backgroundSize: '50px 50px', pointerEvents: 'none' },
  bgGlow: { position: 'fixed', top: '-30%', left: '-10%', width: '70vw', height: '70vw', background: 'radial-gradient(circle,rgba(0,200,255,.06) 0%,transparent 70%)', pointerEvents: 'none' },
  card: { width: '100%', maxWidth: '420px', background: '#0d1420', borderRadius: '20px', border: '1px solid rgba(0,200,255,.15)', padding: '40px 36px', position: 'relative', zIndex: 1 },
  logo: { display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '32px' },
  logoText: { fontFamily: "'Rajdhani',sans-serif", fontSize: '44px', fontWeight: '700', color: '#00C8FF', letterSpacing: '12px', textShadow: '0 0 20px rgba(0,200,255,.5)', marginTop: '8px' },
  logoSub: { color: 'rgba(255,255,255,.25)', fontSize: '11px', letterSpacing: '4px', marginTop: '6px' },
  form: { display: 'flex', flexDirection: 'column', gap: '18px' },
  field: { display: 'flex', flexDirection: 'column', gap: '7px' },
  label: { color: 'rgba(0,200,255,.7)', fontSize: '11px', fontWeight: '700', letterSpacing: '3px' },
  input: { background: 'rgba(255,255,255,.04)', border: '1px solid rgba(0,200,255,.15)', borderRadius: '12px', padding: '13px 16px', color: '#fff', fontSize: '15px', fontFamily: "'Exo 2',sans-serif", transition: 'border-color .2s' },
  btn: { background: '#00C8FF', border: 'none', borderRadius: '12px', padding: '15px', color: '#080c14', fontSize: '15px', fontWeight: '900', letterSpacing: '2px', cursor: 'pointer', marginTop: '8px', fontFamily: "'Rajdhani',sans-serif", transition: 'all .2s' },
  switchText: { textAlign: 'center', color: 'rgba(255,255,255,.3)', fontSize: '14px', marginTop: '24px' },
  switchLink: { color: '#00C8FF', fontWeight: '700', textDecoration: 'none' },
};